






















































































































import {Component, Emit, Mixins, Prop} from "vue-property-decorator";
import {mapGetters, mapMutations} from "vuex";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import AsyncJob from "@/models/async-job";
import {AsyncJobStatus} from "@/assets/scripts/async-status";
import asyncJob from "@/models/async-job";
import DocGetterMixin from "@/components/mixins/DocGetter.vue";

@Component({
  components: {},
  computed: {
    ...mapGetters("asyncJobs", {
      totalCount: "totalCount",
      completedCount: "completedCount",
      asyncJobs: "asyncJobs",
      asyncInWorkTasks: "asyncInWorkTasks",
      asyncInWorkTasksIds: "asyncInWorkTasksIds",
    }),
    iconName() {
      if (this.totalCount <= 0) {
        return "mdi-circle-outline";
      }
      let num = Math.round(this.completedCount * 8 / this.totalCount);
      num = Math.max(num, 1);
      num = Math.min(num, 8);
      return "mdi-circle-slice-" + num.toString();
    },
    preparedAsyncJobs() {
      return this.asyncJobs;
    },
  },
  methods: {
    ...mapMutations("asyncJobs", {
      setAsyncJobs: "setAsyncJobs",
    }),
  },
})
class AsyncDropdown extends Mixins(AppApiMixin, DocGetterMixin) {
  @Prop({ default: false }) readonly isMobile!: boolean;

  items = [];

  mounted() {
    this.statusTimer();
  }

  /**
   * Цикл для получения результатов асинхронных задач по таймеру
   */
  statusTimer() {
    if (this.asyncInWorkTasksIds.length > 0) {
      // проверяем статусы только если есть что проверять
      this.statusAsyncJobs(this.asyncInWorkTasksIds);
    }
    setTimeout(() => this.statusTimer(), 3000);
  }

  /**
   * Остановка асинхронной задачи
   *
   * @param asyncId - идентификатор асинхронной задачи
   */
  stopJob(asyncId: number) {
    this.stopAsyncJob(asyncId);
    this.statusAsyncJobs(this.asyncInWorkTasksIds);
  }

  /**
   * Удаление асинхронной задачи
   *
   * @param asyncId - идентификатор асинхронной задачи
   */
  deleteJob(asyncId: string) {
    const asyncJobs = this.asyncJobs.filter(el => el.asyncId != asyncId);
    this.setAsyncJobs(asyncJobs);
  }

  /**
   * Запуск функции для обработки результата
   *
   * @param item - асинхронная задача
   */
  runCallback(item: AsyncJob) {
    if (item.download) {
      this.downloadAsyncJob({asyncId: item.asyncId, resultId: item.resultId})
        .then((response) => {
          if (item.callback != undefined) {
            item.callback(response);
          }
        });
    } else {
      this.resultAsyncJob({asyncId: item.asyncId, resultId: item.resultId})
        .then((response) => {
          if (item.callback != undefined) {
            item.callback(response);
          }
        });
    }
  }

  /**
   * В работе ли задача
   *
   * @param status - статус задачи
   */
  jobInProcess(status: number) {
    return status == AsyncJobStatus.PROCESS;
  }

  /**
   * Есть результат завершенной асинхронной задачи и есть возможность его обработки
   *
   * @param item - асинхронная задача
   */
  hasResult(item: asyncJob) {
    return item.status == AsyncJobStatus.SUCCESS && (item.download || item.callback != undefined);
  }

  /**
   * Вид иконки результата асинхронной задачи
   *
   * @param item - асинхронная задача
   */
  resultIcon(item: asyncJob) {
    return item.download ? 'mdi-download' : 'mdi-information';
  }

  /**
   * Можно ли удалять асинхронную задачу
   *
   * @param item - асинхронная задача
   */
  canDeleteJob(item: AsyncJob) {
    return [AsyncJobStatus.SUCCESS, AsyncJobStatus.CANCELLED, AsyncJobStatus.ERROR].includes(item.status);
  }

  /**
   * Отображение дополнительного текста асинхронной задачи
   *
   * @param item - асинхронная задача
   */
  showDescription(item: AsyncJob) {
    return (item.description || "") != "";
  }

  /**
   * Отображение результата асинхронной задачи
   *
   * @param item - асинхронная задача
   */
  showResult(item: AsyncJob) {
    if (item.status == AsyncJobStatus.SUCCESS) {
      if (!item.download) {
        return true;
      }
    } else if ([AsyncJobStatus.CANCELLED, AsyncJobStatus.ERROR].includes(item.status)) {
      return true;
    }
    return false;
  }

  /**
   * Класс для отображения дополнительного текста
   *
   * @param item - асинхронная задача
   */
  resultClass(item: AsyncJob) {
    if ([AsyncJobStatus.CANCELLED, AsyncJobStatus.ERROR].includes(item.status)) {
      return "error--text";
    }
    return "";
  }

  /**
   * Дополнительный текст
   *
   * @param item - асинхронная задача
   */
  resultText(item: AsyncJob) {
    switch (item.status) {
      case AsyncJobStatus.SUCCESS: return "Выполнено";
      case AsyncJobStatus.CANCELLED: return "Задача отменена";
      case AsyncJobStatus.ERROR: return item.error || "Неизвестная ошибка";
    }
    return "";
  }

  clearJobs() {
    this.asyncJobs.forEach(job => {
      if (job.status == AsyncJobStatus.PROCESS) {
        this.stopJob(job.asyncId);
      }
    });
    this.setAsyncJobs();
  }

  @Emit("click")
  public propagateCustomEvt(evtName: string) {
    this.$emit(evtName, evtName);
  }
}

export default AsyncDropdown;
